import { Properties } from 'posthog-js';
import { PageViewData } from './BaseTrackingService';

export class LocalTrackerService implements TrackerService {
    track(event: string, properties?: Properties): void {
        // Format table Data
        const tableData: Record<string, any> = {
            eventName: event,
        };

        // Add properties to table Data if they exist
        if (properties) {
            Object.entries(properties).forEach(([key, value]) => {
                tableData[key] = value;
            });
        }

        console.log('[LOCAL STACK] Track:');
        console.table({ event: tableData });
    }

    pageView(properties?: PageViewData): void {
        console.log('[LOCAL STACK] PageView:', properties);
    }

    identify(userId: string, properties?: Properties): void {
        console.log('[LOCAL STACK] Identify:', userId, properties);
    }

    setPersonProperties(properties: Properties): void {
        console.log('[LOCAL STACK] SetPersonProperties:', properties);
    }

    group(type: string, key: string, properties?: Properties): void {
        console.log('[LOCAL STACK] Group:', type, key, properties);
    }

    captureException(error: unknown, properties?: Properties): void {
        console.log('[LOCAL STACK] CaptureException:', error, properties);
    }

    reset(): void {
        console.log('[LOCAL STACK] Reset');
    }
}
